import { AlertCircle, AlertTriangle, CheckCircle, Info } from 'lucide-react';

export interface Toast {
    id: string;
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    message?: string;
    duration?: number;
}

export interface ToastContextType {
    addToast: (toast: Omit<Toast, 'id'>) => void;
    removeToast: (id: string) => void;
}

export const TOAST_ICONS = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
    warning: AlertTriangle
};

export const TOAST_VARIANTS = {
    success: {
        base: 'bg-green-50 dark:bg-green-900/90 border-green-200 dark:border-green-300',
        title: 'text-green-800 dark:text-green-200',
        icon: 'text-green-500 dark:text-green-400',
        message: 'text-green-700 dark:text-green-300'
    },
    error: {
        base: 'bg-red-50 dark:bg-red-900/90 border-red-200 dark:border-red-300',
        title: 'text-red-800 dark:text-red-200',
        icon: 'text-red-500 dark:text-red-400',
        message: 'text-red-700 dark:text-red-300'
    },
    warning: {
        base: 'bg-yellow-50 dark:bg-yellow-900/90 border-yellow-200 dark:border-yellow-300',
        title: 'text-yellow-800 dark:text-yellow-200',
        icon: 'text-yellow-500 dark:text-yellow-400',
        message: 'text-yellow-700 dark:text-yellow-300'
    },
    info: {
        base: 'bg-blue-50 dark:bg-blue-900/90 border-blue-200 dark:border-blue-300',
        title: 'text-blue-800 dark:text-blue-200',
        icon: 'text-blue-500 dark:text-blue-400',
        message: 'text-blue-700 dark:text-blue-300'
    }
};